import { useCallback, useMemo } from 'react';
import { LoginUseCase } from './login.use-case';
import { useLoginModalProvider } from './useLoginModalProvider';
import { useOTPCodeModalProvider } from './useOTPCodeModalProvider';

export const useLoginUseCaseFactory = () => {
  const loginModalProvider = useLoginModalProvider();
  const otpCodeModalProvider = useOTPCodeModalProvider();
  return useCallback(() => {
    return new LoginUseCase(loginModalProvider, otpCodeModalProvider);
  }, [loginModalProvider, otpCodeModalProvider]);
};

export const useLoginUseCase = (): LoginUseCase => {
  const factory = useLoginUseCaseFactory();
  return useMemo(factory, [factory]);
};
